import React from 'react';
import { motion } from 'framer-motion';
import { Smartphone, Brain, MessageCircleHeart, Image as ImageIcon, Lock, Sparkles, Heart, Compass } from 'lucide-react';
export function IdentificationSection() {
  const pains = [{
    icon: <Smartphone size={20} data-id="element-219" />,
    text: 'Revisas su WhatsApp, su última conexión o sus redes "solo para ver" si publicó algo.'
  }, {
    icon: <Brain size={20} data-id="element-220" />,
    text: 'Reproduces en bucle la última conversación, las últimas palabras, el último mensaje.'
  }, {
    icon: <MessageCircleHeart size={20} data-id="element-221" />,
    text: 'Imaginas el momento en que él te busca, se disculpa o te explica todo lo que pasó.'
  }, {
    icon: <ImageIcon size={20} data-id="element-222" />,
    text: 'Te sigues sintiendo conectada a su ropa, sus canciones, los lugares que compartían.'
  }, {
    icon: <Lock size={20} data-id="element-223" />,
    text: 'No puedes cerrar el ciclo internamente, aunque sabes que él ya no va a volver.'
  }];
  const hopes = [{
    icon: <Sparkles size={18} data-id="element-224" />,
    text: 'No estás "loca" ni eres débil por sentir esto. Eres una mujer humana sintiendo una pérdida real.'
  }, {
    icon: <Heart size={18} data-id="element-225" />,
    text: 'El cierre no te lo va a dar él. Te lo das tú, desde tu propia decisión.'
  }, {
    icon: <Compass size={18} data-id="element-226" />,
    text: 'Puedes recuperar tu centro, tu paz y tu poder, paso a paso, en tus términos.'
  }];
  return <section className="py-20 md:py-24 px-4 bg-blush relative" data-id="element-227">
      <div className="max-w-3xl mx-auto" data-id="element-228">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-229">
          <h2 className="font-serif font-bold text-3xl md:text-5xl text-primary mb-6 leading-tight" data-id="element-230">
            ¿Por qué es tan difícil soltarlo cuando{' '}
            <span className="italic" data-id="element-231">racionalmente</span> sabes que él ya no va
            a volver?
          </h2>
        </motion.div>

        <div className="space-y-5 text-base md:text-lg text-ink/80 leading-relaxed mb-10 font-sans" data-id="element-232">
          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} data-id="element-233">
            Tu mente lógica ya entendió que la historia llegó a su fin. Sabes
            que él no te eligió, que no te valoró como mereces, que no te hace
            bien.{' '}
            <span className="font-bold text-primary" data-id="element-234">
              Pero hay una desconexión profunda entre lo que piensas y lo que
              sientes.
            </span>
          </motion.p>
          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} data-id="element-235">
            Tu corazón y tu sistema nervioso siguen enganchados a él. Siguen
            buscando la familiaridad de ese vínculo, esperando una resolución
            que <em data-id="element-236">tal vez nunca llegue</em>.
          </motion.p>
          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} className="font-bold text-primary text-xl md:text-2xl font-serif italic text-center pt-4" data-id="element-237">
            Y por eso te descubres haciendo cosas que te prometiste no volver a
            hacer:
          </motion.p>
        </div>

        <div className="bg-white rounded-2xl p-6 md:p-8 border border-urgency/20 shadow-lg mb-10" data-id="element-238">
          <ul className="space-y-4" data-id="element-239">
            {pains.map((item, i) => <motion.li key={i} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.08
          }} className="flex items-start gap-3 text-ink/85 font-sans" data-id="element-240">
                <div className="shrink-0 w-9 h-9 rounded-full bg-urgency/10 text-urgency flex items-center justify-center" data-id="element-241">
                  {item.icon}
                </div>
                <span className="pt-1.5" data-id="element-242">{item.text}</span>
              </motion.li>)}
          </ul>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-gradient-to-br from-relief/10 to-white rounded-2xl p-6 md:p-8 border-2 border-relief/30 shadow-md" data-id="element-243">
          <p className="font-serif font-bold text-xl md:text-2xl text-primary mb-5 text-center italic" data-id="element-244">
            Mujer, quiero que sepas algo importante:
          </p>
          <ul className="space-y-3" data-id="element-245">
            {hopes.map((item, i) => <li key={i} className="flex items-start gap-3 text-primary font-sans font-semibold" data-id="element-246">
                <div className="shrink-0 w-8 h-8 rounded-full bg-relief text-white flex items-center justify-center" data-id="element-247">
                  {item.icon}
                </div>
                <span className="pt-1" data-id="element-248">{item.text}</span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}